<template>
  <base-section id="affiliates" class="grey lighten-4" space="36">
    <v-container>
      <base-section-heading title="Wear Hue in the news" />

      <v-slide-group>
        <template v-for="n in 1">
          <v-slide-item :key="n" class="align-self-center">
            <a
              href="https://www.androidpolice.com/theres-a-new-way-to-control-your-philips-hue-lights-right-from-your-wrist"
            >
              <base-img
                :src="require(`@/assets/ap-og-img.png`)"
                color="grey"
                contain
                height="40"
                width="128"
              />
            </a>
          </v-slide-item>

          <!-- <v-responsive
            v-if="n < 1"
            :key="`divider-${n}`"
            class="text-center"
            height="56"
            width="48"
          >
            <v-divider vertical />
          </v-responsive> -->
        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: 'SectionAffiliates',
}
</script>
